import { Grid6, Element4 } from "iconsax-react";
import { ButtonGroup } from "@/shared/ui";

interface Props {
  value: "table" | "cards";
  onChange: (v: "table" | "cards") => void;
  tableLabel: string;
  cardsLabel: string;
}

export default function ViewModeToggle({ value, onChange, tableLabel, cardsLabel }: Props) {
  return (
    <ButtonGroup
      options={[
        {
          label: (
            <>
              <Grid6 size={16} color="currentColor" />
              {tableLabel}
            </>
          ),
          value: "table",
        },
        {
          label: (
            <>
              <Element4 size={16} color="currentColor" />
              {cardsLabel}
            </>
          ),
          value: "cards",
        },
      ]}
      value={value}
      onChange={(v) => onChange(v as "table" | "cards")}
    />
  );
}
